import styles from "./style.module.scss";
import React from "react";
import classNames from "classnames";

interface VLColorfulLoaderProps {
  text?: string;
  className?: string;
}
export default function VLColorfulLoader({
  text,
  className,
}: VLColorfulLoaderProps) {
  return (
    <div
      className={classNames(styles.loadingContainer, className)}
      data-testid="vl-loader"
    >
      <div className={styles.spinner}></div>
      {text && <div className={styles.text}>{text}</div>}
    </div>
  );
}
